var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcatChatIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3272be",
    d: "M5.496 28.846c9.6-1.491 15.096-6.781 16.596-16.13.874 4.083 2.166 7.885 5.242 10.888 3.125 3.05 7.02 4.452 11.455 5.198-9.608 1.494-15.187 6.75-16.645 16.231C20.6 35.713 15.202 30.28 5.493 28.85zM22.141 11.43c-5.964 1.108-9.5 4.314-10.594 10.102-1.27-5.643-4.64-9.152-10.95-9.948Q8.805 8.307 11.616.967c.97 6.051 4.542 9.359 10.525 10.463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3272be",
    d: "M33.716 7.826c1.105 4.436 3.53 7 8.01 7.795-4.388.978-6.932 3.38-7.967 7.869-1.057-4.5-3.618-6.916-8.68-7.81 4.987-.963 7.655-3.286 8.636-7.859z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcatChatIconDark);
export default __webpack_public_path__ + "static/media/mcat-chat-icon-dark.95be7e5de6390cc2d65327d43f09a841.svg";
export { ForwardRef as ReactComponent };